<template>
  <textarea
    :value="modelValue"
    rows="4"
    class="block w-full text-gray-900 bg-gray-50 rounded-lg border-2 border-gray-200 focus:ring-2 focus:ring-primary-500
      focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white
      dark:focus:ring-primary-500 dark:focus:border-primary-500"
    :class="[INPUT_SIZES[size]]"
    @input="$emit('update:modelValue', $event.target.value)" />
</template>

<script setup>
const INPUT_SIZES = {
  default: 'px-3 py-2 text-base',
  lg: 'px-3 py-4 text-lg',
  sm: 'px-3 py-1.5 text-sm'
}

defineProps({
  modelValue: {
    required: true,
    validator: (prop) => typeof prop === 'string' || prop === null
  },
  size: {
    type: String,
    required: false,
    default: 'default',
    validator: (prop) => ['default', 'lg', 'sm'].includes(prop)
  }
})

defineEmits(['update:modelValue'])
</script>
